import cloneDeep from 'lodash/fp/cloneDeep'
import { events } from './AdviserProfilesContainerActions'

const initialState = {
  fetchingAdvisers: false,
  fetchedAdviserStatusCodes: false,
  advisers: [],
  adviserStatusCodes: [],
  submitAdviser: false,
  submittingAdviser: false,
  submittedAdviser: false,
  adviserIndex: -1,
  searchTerm: null
}

export default (state = initialState, action) => {
  const { load, set, submitting, submitted } = events
  let newState = cloneDeep(state)

  switch (action.type) {
    case load.fetching:
      newState.fetchingAdvisers = true
      return newState
    case load.fetched:
      newState.fetchingAdvisers = false
      newState.advisers = action.payload
      return newState
    case load.fetchedAdviserStatusCodes:
      newState.fetchedAdviserStatusCodes = true
      newState.adviserStatusCodes = action.payload
      return newState
    case set.setAdviserStatusCode:
      newState.submittedAdviser = false
      newState.adviserIndex = action.index
      newState.submitAdviser = true
      newState.advisers[newState.adviserIndex].adviserStatusCodeId = action.statusCode
      return newState
    case set.searchTerm:
      newState.searchTerm = action.searchTerm
      return newState
    case submitting.adviser:
      newState.submitAdviser = false
      newState.submittingAdviser = true
      return newState
    case submitted.adviser:
      newState.submittingAdviser = false
      newState.submittedAdviser = true
      return newState
    default:
      return state
  }
}
